export const msalConfig = {
  auth: {
    clientId: "3de7856e-82b4-4c0d-acab-9b6acce3618a",
    authority:
      "https://login.microsoftonline.com/e754e302-efe0-453e-ad37-753333adbb42",
    redirectUri: process.env.REACT_APP_REDIRECT_URI
      ? process.env.REACT_APP_REDIRECT_URI
      : "http://localhost:3000",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "offline_access", "User.Read"],
};

export const graphRequest = {
  scopes: ["User.Read"],
};

export const backendRequest = {
  scopes: ["api://9cc17273-0e03-422b-8798-b45fc58bba76/access"],
};
